import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useSiteContent } from "../../context/SiteContentContext";

export default function FeastsTable() {
  const [rows, setRows] = useState([]);
  const { tables } = useSiteContent();

  useEffect(() => {
    fetch("/data/feasts.json")
      .then((res) => res.json())
      .then((json) => {
        const formatted = (json?.feasts ?? []).map((feast, index) => ({
          id: index,
          name: feast.name ?? "—",
          date: feast.raw_date ?? feast.date ?? "—",
          person: feast.person ?? "—",
          notes: feast.notes ?? "—",
        }));

        setRows(formatted);
      })
      .catch((err) => console.error("تعذر تحميل ملف الأعياد:", err));
  }, []);

  return (
    <TableContainer
      component={Paper}
      sx={{
        direction: "rtl",
        mt: 3,
        maxHeight: 480,
      }}
    >
      <Table stickyHeader aria-label="جدول الأعياد">
        <TableHead>
          <TableRow>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              {tables.feastsNameLabel}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              {tables.dateLabel}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              {tables.feastPersonLabel}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>
              {tables.notesLabel}
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell align="right" colSpan={4}>
                {tables.emptyLabel}
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell align="right">{row.name}</TableCell>
                <TableCell align="right">{row.date}</TableCell>
                <TableCell align="right">{row.person}</TableCell>
                <TableCell align="right">{row.notes}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
